import { render, staticRenderFns } from "./StepFourIcon.vue?vue&type=template&id=f3b4262c&"
import script from "./StepFourIcon.vue?vue&type=script&lang=js&"
export * from "./StepFourIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports